var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPageAnaly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_page-analy",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1000",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1064",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_707",
    d: "M11.286 21.8H6.211V4.2h7.737v5.5h5.526v2.087a6.951 6.951 0 0 1 2.211 1.179V8.6L15.053 2H6.211a2.2 2.2 0 0 0-2.2 2.2L4 21.8A2.2 2.2 0 0 0 6.2 24h7.062a6.977 6.977 0 0 1-1.976-2.2z",
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1063",
    transform: "translate(12.378 13.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_708",
    d: "M20.754 19.98a4.887 4.887 0 0 0 .774-2.628 5.013 5.013 0 1 0-2.343 4.179l3.448 3.431L24.2 23.4zm-4.2.121a2.749 2.749 0 1 1 2.763-2.749 2.757 2.757 0 0 1-2.763 2.748z",
    className: "cls-2",
    transform: "translate(-11.58 -12.403)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPageAnaly);
export default __webpack_public_path__ + "static/media/icon-page-analy.bac393d5.svg";
export { ForwardRef as ReactComponent };